import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SubscriptionSection = ({ subscriptions, onUpdate }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedChannels, setSelectedChannels] = useState([]);

  const mockSubscriptions = [
  {
    id: 1,
    channelName: "Философия Присутствия",
    channelAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae0f3431-1763296290027.png",
    channelAvatarAlt: "Профессиональное фото мужчины в черной рубашке с задумчивым выражением лица на нейтральном фоне",
    subscribedDate: "15.11.2025",
    notificationsEnabled: true,
    lastBroadcast: "2 дня назад"
  },
  {
    id: 2,
    channelName: "Звуки Острова",
    channelAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d48526bd-1763295298208.png",
    channelAvatarAlt: "Портрет улыбающейся женщины с длинными темными волосами в белой блузке на светлом фоне",
    subscribedDate: "03.11.2025",
    notificationsEnabled: true,
    lastBroadcast: "5 часов назад"
  },
  {
    id: 3,
    channelName: "Медитативные Частоты",
    channelAvatar: "https://images.unsplash.com/photo-1588120636681-522f2b1d2824",
    channelAvatarAlt: "Мужчина с бородой в синей рубашке смотрит в камеру на размытом природном фоне",
    subscribedDate: "28.10.2025",
    notificationsEnabled: false,
    lastBroadcast: "1 день назад"
  },
  {
    id: 4,
    channelName: "Голос Тишины",
    channelAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_193a7713e-1764707595149.png",
    channelAvatarAlt: "Женщина с рыжими волосами в сером свитере улыбается на камеру в помещении с естественным освещением",
    subscribedDate: "20.10.2025",
    notificationsEnabled: true,
    lastBroadcast: "3 дня назад"
  },
  {
    id: 5,
    channelName: "Аутентичные Разговоры",
    channelAvatar: "https://images.unsplash.com/photo-1714976371980-7f7c9da73450",
    channelAvatarAlt: "Мужчина в очках и клетчатой рубашке с дружелюбной улыбкой на городском фоне",
    subscribedDate: "12.10.2025",
    notificationsEnabled: true,
    lastBroadcast: "6 часов назад"
  }];


  const filteredSubscriptions = mockSubscriptions?.filter((sub) =>
  sub?.channelName?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleToggleNotifications = (channelId) => {
    console.log('Toggle notifications for channel:', channelId);
  };

  const handleUnsubscribe = (channelId) => {
    console.log('Unsubscribe from channel:', channelId);
  };

  const handleSelectChannel = (channelId) => {
    setSelectedChannels((prev) =>
    prev?.includes(channelId) ?
    prev?.filter((id) => id !== channelId) :
    [...prev, channelId]
    );
  };

  const handleBulkUnsubscribe = () => {
    console.log('Bulk unsubscribe:', selectedChannels);
    setSelectedChannels([]);
  };

  return (
    <div className="subscription-section bg-card rounded-lg p-6 shadow-soft">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Users" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Подписки
          </h2>
          <p className="text-sm text-muted-foreground">
            Управление подписками на каналы
          </p>
        </div>
      </div>
      <div className="subscription-controls mb-6">
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Поиск по подпискам..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)} />

          </div>
          {selectedChannels?.length > 0 &&
          <Button
            variant="destructive"
            iconName="Trash2"
            iconPosition="left"
            onClick={handleBulkUnsubscribe}>

              Отписаться ({selectedChannels?.length})
            </Button>
          }
        </div>
      </div>
      <div className="subscription-stats mb-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div className="stat-card p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Radio" size={16} color="var(--color-primary)" />
            <span className="text-xs text-muted-foreground">Всего подписок</span>
          </div>
          <p className="text-2xl font-heading font-semibold text-foreground">
            {mockSubscriptions?.length}
          </p>
        </div>
        <div className="stat-card p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Bell" size={16} color="var(--color-primary)" />
            <span className="text-xs text-muted-foreground">С уведомлениями</span>
          </div>
          <p className="text-2xl font-heading font-semibold text-foreground">
            {mockSubscriptions?.filter((s) => s?.notificationsEnabled)?.length}
          </p>
        </div>
        <div className="stat-card p-4 bg-muted/50 rounded-lg col-span-2 sm:col-span-1">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Activity" size={16} color="var(--color-primary)" />
            <span className="text-xs text-muted-foreground">Активных</span>
          </div>
          <p className="text-2xl font-heading font-semibold text-foreground">
            {mockSubscriptions?.filter((s) => s?.lastBroadcast?.includes('час'))?.length}
          </p>
        </div>
      </div>
      <div className="subscription-list space-y-3">
        {filteredSubscriptions?.map((subscription) =>
        <div
          key={subscription?.id}
          className="subscription-item p-4 bg-background rounded-lg border border-border hover:border-primary/50 transition-colors duration-200">

            <div className="flex items-center gap-4">
              <input
              type="checkbox"
              checked={selectedChannels?.includes(subscription?.id)}
              onChange={() => handleSelectChannel(subscription?.id)}
              className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary cursor-pointer"
              aria-label={`Выбрать канал ${subscription?.channelName}`} />

              
              <div className="channel-avatar w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <Image
                src={subscription?.channelAvatar}
                alt={subscription?.channelAvatarAlt}
                className="w-full h-full object-cover" />

              </div>

              <div className="channel-info flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground truncate">
                  {subscription?.channelName}
                </h3>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-muted-foreground">
                    Подписка: {subscription?.subscribedDate}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    • Эфир: {subscription?.lastBroadcast}
                  </span>
                </div>
              </div>

              <div className="channel-actions flex items-center gap-2">
                <button
                onClick={() => handleToggleNotifications(subscription?.id)}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                subscription?.notificationsEnabled ?
                'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
                }
                aria-label={subscription?.notificationsEnabled ? 'Отключить уведомления' : 'Включить уведомления'}
                title={subscription?.notificationsEnabled ? 'Отключить уведомления' : 'Включить уведомления'}>

                  <Icon
                  name={subscription?.notificationsEnabled ? 'Bell' : 'BellOff'}
                  size={18}
                  color="currentColor" />

                </button>
                <button
                onClick={() => handleUnsubscribe(subscription?.id)}
                className="p-2 rounded-lg bg-muted text-muted-foreground hover:bg-destructive/10 hover:text-destructive transition-colors duration-200"
                aria-label="Отписаться"
                title="Отписаться">

                  <Icon name="UserMinus" size={18} color="currentColor" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {filteredSubscriptions?.length === 0 &&
      <div className="empty-state py-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
          </div>
          <h3 className="text-lg font-medium text-foreground mb-2">
            Подписки не найдены
          </h3>
          <p className="text-sm text-muted-foreground">
            Попробуйте изменить поисковый запрос
          </p>
        </div>
      }
    </div>);

};

export default SubscriptionSection;